module.exports = require('./dist').default;
module.exports.default = module.exports;




// WEBPACK FOOTER //
// ./~/inferno-component/index.js